import "./styles.less";

import { Avatar, Button, Card, Col, Row, Space } from "antd";
import { FC, useState, useContext } from "react";

import { ModalPhone } from "../../ModalPhone/web";
import Text from "antd/lib/typography/Text";
import { usePhoneButton } from "../../InformationRequest/LeadButtons/PhoneButton/hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

interface OwnerProps {
	property_id: string;
	name: string;
	maskedPhone: string;
	mode: string;
	logo?: string;
	disabled?: boolean;
}

export const Owner: FC<OwnerProps> = ({
	property_id,
	name,
	maskedPhone,
	mode,
	logo = null,
	disabled = false,
}) => {
	const [modal, setModal] = useState(false);
	const { country_code } = useContext(ConfigStateContext);

	const { viewPhone, phone, loading } = usePhoneButton({ property_id });

	const handleClick = (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		if (!phone) {
			viewPhone().then(data => {
				if (data) setModal(true);
			});
		} else {
			setModal(true);
		}
	};

	return (
		<>
			<Card size="small" className="owner">
				<Row gutter={16} align="middle">
					<Col>
						<Avatar alt={name}>{name[0]?.toUpperCase()}</Avatar>
					</Col>
					<Col
						flex={1}
						className="left"
						style={{ overflow: "hidden", position: "relative" }}>
						<Text>{name}</Text>
					</Col>
					<Col>
						{country_code !== "BR" && (
							<Space size={4}>
								<Text className="masked">{maskedPhone}</Text>
								{maskedPhone && (
									<Button
										loading={loading}
										onClick={handleClick}
										className="secondary"
										disabled={disabled}>
										{"Ver teléfono"}
									</Button>
								)}
							</Space>
						)}
					</Col>
				</Row>
			</Card>
			<ModalPhone
				mode={mode}
				phone={phone}
				owner_name={name}
				property_id={property_id}
				loading={loading}
				visible={modal}
				onCancel={() => setModal(false)}
			/>
		</>
	);
};
